import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

function Blob({ styles: customStyles }) {
  return (
    <img
      className={classnames([styles.blobImage, ...customStyles])}
      src="/assets/images/blob.png"
      alt="Norwegian Block Exchange"
    />
  );
}

Blob.propTypes = {
  styles: PropTypes.array
};

Blob.defaultProps = {
  styles: []
};

export default Blob;
